import { cn } from '@/shared/utils'

import type { HTMLAttributes, PropsWithChildren } from 'react'

export interface FlexBoxProps extends HTMLAttributes<HTMLElement> {
  pb?: string | number
  pt?: string | number
  px?: string | number
  pl?: string | number
  pr?: string | number
  py?: string | number

  mb?: string | number
  mt?: string | number
  ml?: string | number
  mr?: string | number
  mx?: string | number
  my?: string | number

  gap?: string | number
  items?: 'center' | 'start' | 'end' | 'stretch' | 'baseline'
  justify?: 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'start' | 'end' | 'stretch' | 'normal'
  wrap?: boolean
  flex?: number
  width?: string | number
  height?: string | number
  bg?: string

  row?: boolean
  col?: boolean
  full?: boolean
  hidden?: boolean

  elementType?:
    | 'div'
    | 'span'
    | 'p'
    | 'button'
    | 'a'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'li'
    | 'ul'
    | 'ol'
    | 'pre'
}

const FlexBox: React.FC<PropsWithChildren<FlexBoxProps>> = ({
  children,
  row,
  col,
  full,
  hidden,
  className,
  elementType,
  ...props
}) => {
  const Element = elementType || 'div'

  return (
    <Element
      style={{
        backgroundColor: props.bg,
        alignItems: props.items,
        gap: props.gap,
        justifyContent: props.justify,
        marginTop: props.mt || props.my,
        marginBottom: props.mb || props.my,
        marginLeft: props.ml || props.mx,
        marginRight: props.mr || props.mx,
        paddingTop: props.pt || props.py,
        paddingBottom: props.pb || props.py,
        paddingRight: props.pr || props.px,
        paddingLeft: props.pl || props.px,
        width: props.width,
        height: props.height,
      }}
      className={cn(
        'flex',
        row ? 'flex-row' : col ? 'flex-col' : 'flex-row',
        row && full ? 'w-full' : '',
        col && full ? 'h-full' : '',
        props.wrap ? 'flex-wrap' : '',
        hidden ? 'hidden' : '',
        className,
      )}
      {...props}
    >
      {children}
    </Element>
  )
}

export default FlexBox
